import api from './api';

export const authService = {
  /**
   * Register a new user
   */
  async register(email, password, firstName, lastName) {
    const response = await api.post('/auth/register', {
      email,
      password,
      firstName,
      lastName,
    });
    return response.data.data;
  },

  /**
   * Login user
   */
  async login(email, password) {
    const response = await api.post('/auth/login', {
      email,
      password,
    });
    return response.data.data;
  },

  /**
   * Refresh access token
   */
  async refresh(refreshToken) {
    const response = await api.post('/auth/refresh', {
      refreshToken,
    });
    return response.data.data;
  },

  /**
   * Logout user
   */
  async logout(refreshToken) {
    const response = await api.post('/auth/logout', {
      refreshToken,
    });
    return response.data;
  },

  /**
   * Request password reset
   */
  async requestPasswordReset(email) {
    const response = await api.post('/auth/password-reset-request', {
      email,
    });
    return response.data;
  },

  /**
   * Reset password with token
   */
  async resetPassword(token, password) {
    const response = await api.post('/auth/password-reset', {
      token,
      password,
    });
    return response.data;
  },

  /**
   * Verify email
   */
  async verifyEmail(token) {
    const response = await api.get(`/auth/verify-email/${token}`);
    return response.data;
  },

  /**
   * Resend verification email
   */
  async resendVerification(email) {
    const response = await api.post('/auth/resend-verification', {
      email,
    });
    return response.data;
  },

  /**
   * Get current user
   */
  async getCurrentUser() {
    const response = await api.get('/auth/me');
    return response.data.data;
  },

  /**
   * Get invite details by token
   */
  async getInviteDetails(token) {
    const response = await api.get(`/auth/invite/${token}`);
    return response.data.data;
  },

  /**
   * Accept invitation and set password
   */
  async acceptInvite(token, password) {
    const response = await api.post('/auth/accept-invite', {
      token,
      password,
    });
    return response.data;
  },

  /**
   * Get Google OAuth consent URL for SSO
   */
  async getGoogleAuthUrl(returnPath = '/events') {
    const response = await api.get(`/auth/google/auth-url?returnPath=${encodeURIComponent(returnPath)}`);
    return response.data.data.url;
  },
};

export default authService;
